/**
 * Internal Dependencies.
 */
import CruiseOverview from '../pages/CruiseOverview.vue';
import CruisePassengers from '../pages/CruisePassengers.vue';
import CruiseDeck from '../pages/CruiseDeck.vue';
import CruiseCabin from '../pages/CruiseCabin.vue';
import CruiseOrder from '../pages/CruiseOrder.vue';

export default [
	{
		name: 'cruise.overview',
		path: '/',
		component: CruiseOverview,
		meta:{
			step: 'overview',
		}
	},
	{
		name: 'cruise.passengers',
		path: '/passengers',
		component: CruisePassengers,
		meta:{
			step: 'passengers',
		}
	},
	{
		name: 'cruise.deck',
		path: '/deck',
		component: CruiseDeck,
		meta:{
			step: 'deck',
		}
	},
	{
		name: 'cruise.cabin',
		path: '/cabin',
		component: CruiseCabin,
		meta:{
			step: 'cabin',
		}
	},
	{
		name: 'cruise.order',
		path: '/order',
		component: CruiseOrder,
		meta:{
			step: 'order',
		}
	},
];



// WEBPACK FOOTER //
// ./src/router/routes.js